import { gql } from "graphql-tag";

import { documentLink } from "~/app/prismic/prismic-fragments";

export const BlogDetail = gql`
  fragment BlogDetail on Blog {
    ...documentLink
    title
    feature_image
    description
  }
  ${documentLink}
`;

export const getListOfArticlesV2 = pageType => gql`
  fragment ${pageType}_list_of_articles_v2 on ${pageType}SlicesList_of_articles_v2 {
    type
    variation {
      ... on ${pageType}SlicesList_of_articles_v2Default {
        primary @skip(if: $lazy) {
          title
        }
        items @include(if: $lazy) {
          blog_link {
            ... BlogDetail
          }
        }
      }
    }
  }
  ${BlogDetail}
`;
